import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { TechUtils } from "./TechUtils"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
  return TechUtils.formatCurrency(amount)
} 